import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { FaMoon, FaSun } from "react-icons/fa";
import styles from './themeToggle.module.css';

const ThemeToggle = () => {
    const { isDarkMode, toggleDarkMode } = useTheme();

    return (
        <div className={styles.toggleWrapper}>
            <FaSun className={styles.sunIcon} />
            <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={isDarkMode}
                    onChange={toggleDarkMode}
                />
                <span className={styles.slider}></span>
            </label>
            <FaMoon className={styles.moonIcon} />
        </div>
    );
};

export default ThemeToggle;
